export const MENU_LOAD = 'MENU_LOAD';
export const MENU_LOAD_PRODUCTS = 'MENU_LOAD_PRODUCTS';
export const MENU_LOAD_CATEGORIES = 'MENU_LOAD_CATEGORIES';
export const MENU_LOAD_ITEMS = 'MENU_LOAD_ITEMS';
export const MENU_LOAD_MODIFIERS = 'MENU_LOAD_MODIFIERS';
export const LAZY_MENU_LOAD = 'LAZY_MENU_LOAD';
export const LAZY_MENU_LOADED = 'LAZY_MENU_LOADED';

export default {
  MENU_LOAD,
  MENU_LOAD_PRODUCTS,
  MENU_LOAD_CATEGORIES,
  MENU_LOAD_ITEMS,
  MENU_LOAD_MODIFIERS,
  LAZY_MENU_LOAD,
  LAZY_MENU_LOADED,
};



// WEBPACK FOOTER //
// ./src/apps/menu/store/types.js